import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import InputField from '../../Reusable/InputField';
import KeybordDatePicker from '../../Reusable/KeyboardDatePicker';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';

const FirstSection = (props) => {
  const {
    onChange,
    state,
    onDateChange,
    onComboBoxChange,
    errors,
    errorsHandler,
  } = props || {};

  return (
    <Card>
      <Card.Header className="primary-header-card">
        <Card.Title className="d-flex gap-3 align-items-center">
          Podaci o patronimu
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={4}>
            <InputField
              id="ipBrojImena"
              name="ipBrojImena"
              placeholder={'IP NAME NUMBER'}
              onChange={onChange}
              value={state.ipBrojImena}
            />
            <ComboBoxAutocomplete
              id="typeOfAuthor"
              data={['Fizičko lice', 'Pravno lice']}
              textExtractor={(a) => a}
              changeValue={(newValue) =>
                onComboBoxChange('typeOfAuthor', newValue)
              }
              label={'Tip autora'}
              updateValue={state.typeOfAuthor}
              required
              error={errors}
              errorsHandler={errorsHandler}
            />
          </Col>
          <Col md={4}>
            <InputField
              id="firstName"
              name="firstName"
              placeholder={'Ime'}
              onChange={onChange}
              value={state.firstName}
            />
            <InputField
              id="lastName"
              name="lastName"
              placeholder={'Prezime'}
              onChange={onChange}
              value={state.lastName}
              required
              error={errors}
              errorsHandler={errorsHandler}
            />
          </Col>
          <Col md={4}>
            <KeybordDatePicker
              id="dateField"
              name="dateField"
              label={'Datum kreiranja imena'}
              onChange={onDateChange}
              placement="bottom"
            />
            <InputField
              id="parentName"
              name="parentName"
              placeholder={'Ime roditelja'}
              onChange={onChange}
              value={state.parentName}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FirstSection;
